import React, { useState } from 'react';
import './Dialog.css';

interface DuplicateProjectDialogProps {
  projectName: string;
  onConfirm: (options: DuplicateOptions) => void;
  onClose: () => void;
}

export interface DuplicateOptions {
  includeCables: boolean;
  includePassthrough: boolean;
  includeSplices: boolean;
  includeSplitters: boolean;
  includeONUs: boolean;
}

const DuplicateProjectDialog: React.FC<DuplicateProjectDialogProps> = ({
  projectName,
  onConfirm,
  onClose,
}) => {
  const [options, setOptions] = useState<DuplicateOptions>({
    includeCables: true,
    includePassthrough: true,
    includeSplices: true,
    includeSplitters: true,
    includeONUs: false,
  });

  const handleCheckboxChange = (key: keyof DuplicateOptions) => {
    setOptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleConfirm = () => {
    onConfirm(options);
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-container" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>📋 Duplikovať projekt</h2>
          <button className="dialog-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="dialog-content">
          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Projekt: <strong>{projectName}</strong>
            </p>
            <p style={{ fontSize: '13px', color: '#888', marginTop: '8px' }}>
              Vyberte, čo chcete zahrnúť do duplikátu:
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                backgroundColor: '#f5f5f5',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={options.includeCables}
                onChange={() => handleCheckboxChange('includeCables')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px' }}>
                  🔌 Káble
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  Všetky optické káble medzi stĺpikmi
                </div>
              </div>
            </label>

            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                backgroundColor: '#f5f5f5',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={options.includePassthrough}
                onChange={() => handleCheckboxChange('includePassthrough')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px' }}>
                  ➡️ Passthrough
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  Priame prepojenia vlákien v kazetách
                </div>
              </div>
            </label>

            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                backgroundColor: '#f5f5f5',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={options.includeSplices}
                onChange={() => handleCheckboxChange('includeSplices')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px' }}>
                  🔗 Zváry
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  Všetky zváry vlákien v kazetách
                </div>
              </div>
            </label>

            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                backgroundColor: '#f5f5f5',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={options.includeSplitters}
                onChange={() => handleCheckboxChange('includeSplitters')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px' }}>
                  🌳 Splittery
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  Všetky splittery a ich konfigurácie
                </div>
              </div>
            </label>

            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                backgroundColor: '#fff3cd',
                borderRadius: '6px',
                cursor: 'pointer',
                border: '1px solid #ffc107',
              }}
            >
              <input
                type="checkbox"
                checked={options.includeONUs}
                onChange={() => handleCheckboxChange('includeONUs')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px' }}>
                  📡 ONU (bez zákazníkov)
                </div>
                <div style={{ fontSize: '12px', color: '#856404' }}>
                  ONU zariadenia bez prepojenia na zákazníkov
                </div>
              </div>
            </label>
          </div>

          <div
            style={{
              marginTop: '20px',
              padding: '12px',
              backgroundColor: '#e3f2fd',
              borderRadius: '6px',
              fontSize: '12px',
              color: '#1976d2',
            }}
          >
            ℹ️ <strong>Poznámka:</strong> Stĺpiky a ich pozície sa vždy duplikujú.
            Nový projekt bude mať názov "{projectName} - Kópia [dátum]"
          </div>
        </div>

        <div className="dialog-footer">
          <button className="btn-secondary" onClick={onClose}>
            Zrušiť
          </button>
          <button className="btn-primary" onClick={handleConfirm}>
            📋 Duplikovať projekt
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateProjectDialog;

